import { useEffect, useState } from "react"
import prodotti_fetch from "../fetch/prodotti_fetch"
import { useNavigate } from "react-router";
import InputForm from "../riutilizabili/forms/InputForm";
import FormError from "../riutilizabili/FormError";
import { format } from "date-fns";
import ViewProdPopUp from "./ViewProdPopUp";
import InfoModal from "../riutilizabili/InfoModal";
import CreaInventario from "./inventario/CreaInventario";
import TendinaArrow from "../riutilizabili/TendinaArrow";
import Attendere from "../riutilizabili/Attendere";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import ConfermaEliminazione from "../riutilizabili/ConfermaEliminazione";
import TabProdSezioniOld from "../ProdSituazione/TabProdSezioniOld";


export default function InventarioPrimaImp({prodottoId , nomeProd , onclose , mostra}) {
    const [qtPrimaImp , setQtPrimaImp] = useState(false)
    const [qtPrimaImpError , setQtPrimaImpError] = useState({})
    const [abilitaMod, setAbilitaMod]  = useState(false)
    const [abilitaCreaInv, setAbilitaCreaInv]  = useState(false)
    const [inputsCrea , setInputsCrea] = useState({dataOraOperazione : format(new Date(), "yyyy-MM-dd'T'HH:mm")})
    const [abilitaModInv, setAbilitaModInv]  = useState(false)
    const [inputsMod , setInputsMod] = useState({})
    const [tendinaStato, setTendinaStato]  = useState(false)
    const [tendinaMovOldStato, setTendinaMovOldStato]  = useState(false)

    const [attivaAttendere , setAttivaAttendere] = useState(false);
    const [confermaElimina , setConfermaElimina] = useState(false);

    useEffect(()=>{
        console.log(prodottoId , ' prodottoId');
        
        if (prodottoId) {
            readQtPrimaImp()
        }
    },[mostra ,prodottoId])
    
    const navigate = useNavigate();

    const onCloseQt = async(stato) => {
        if (stato) {
            try {
                await prodotti_fetch.salvaInvetarioProd(qtPrimaImp)
                setQtPrimaImp(false)
                onclose(false)
                setQtPrimaImpError({})
                readQtPrimaImp()
            } catch (error) {
                setQtPrimaImpError(error?.response?.data)   
                setAttivaAttendere(false) 
            }
            
        }else {
            setQtPrimaImp(false)
            onclose(false)
            setQtPrimaImpError({})
        }

    }

    const calQtIniziale = async () => {
        try {
            const {data} =await prodotti_fetch.calcolaQtIniziale(qtPrimaImp)
            setQtPrimaImp({...qtPrimaImp , ...data})
            setQtPrimaImpError({})
        } catch (error) {
            setQtPrimaImpError(error?.response?.data)
            if (error?.response?.status === 406) {
                navigate("/login");;
            }
        }
    }

    const readQtPrimaImp = async () => {
        try {
            const prod = await prodotti_fetch.readQtProdottoId({prodottoId})
            const now = new Date();

            let formattedDateTime = new Intl.DateTimeFormat("it-IT", {
                timeZone: "Europe/Rome",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).format(now);

            const [date, time] = formattedDateTime.split(", ");
            const [day, month, year] = date.split("/");
            const formattedDate = `${year}-${month}-${day}T${time}`;

            console.log(formattedDate, ' formattedDate');
            
            setAbilitaMod(!!prod.data.modInv)

            setQtPrimaImp({...prod.data , nomeProd , dataOraOperazione : formattedDate})
            setQtPrimaImpError({})
        } catch (error) {
            setQtPrimaImp({ quantita:null , nomeProd})
            setQtPrimaImpError(error?.response?.data)
            if (error?.response?.status === 406) {
                navigate("/login");;
            }
        }
    }

    const creaRigaPrimaImp = async () => {
        try {
            const {data} =await prodotti_fetch.creaRigaPrimaImportazione({prodottoId , sezioneId : 1})
            console.log(data, ' data');
            setQtPrimaImp({...qtPrimaImp , ...data})
            setQtPrimaImpError({})
            readQtPrimaImp()
        } catch (error) {
            setQtPrimaImpError(error?.response?.data)
            if (error?.response?.status === 406) {
                navigate("/login");;
            }
        }
    }

    const onCloseInv = async (stato) => {
        if (stato) {
            try {
                setTendinaStato(false)
                setAttivaAttendere(true)
                await prodotti_fetch.salvaInvetarioProd({...inputsCrea , prodottoId , qtAttuale : qtPrimaImp.qtAttuale})
                setAbilitaCreaInv(false)
                setInputsCrea({dataOraOperazione : format(new Date(), "yyyy-MM-dd'T'HH:mm")})
                setQtPrimaImpError({})
                setAttivaAttendere(false)
                setTendinaStato(true)
                await readQtPrimaImp()
                setAbilitaMod(true)

            } catch (error) {
                setQtPrimaImpError(error?.response?.data)    
                setAttivaAttendere(false)
            }
        } else {
            setAbilitaCreaInv(false)
            setInputsCrea({dataOraOperazione : format(new Date(), "yyyy-MM-dd'T'HH:mm")})
            setQtPrimaImpError({})
            setAttivaAttendere(false)
        }
    }

    const onCloseInvMod = async (stato) => {
        if (stato) {
            try {
                setTendinaStato(false)
                setAttivaAttendere(true)
                await prodotti_fetch.editInvetarioProd({...inputsMod , prodottoId})
                await readQtPrimaImp()
                setAbilitaModInv(false)
                setAbilitaMod(true)
                setInputsMod({})
                setQtPrimaImpError({})
                setAttivaAttendere(false)
                setTendinaStato(true)
            } catch (error) {
                setQtPrimaImpError(error?.response?.data)   
                setAttivaAttendere(false) 
            }
        } else {
            setAbilitaModInv(false)
            setInputsMod({})
            setQtPrimaImpError({})
        }
    }

    console.log(qtPrimaImp ,' qtPrimaImp');

    const deleteInv = async (stato) => {
        if (stato) {
            setAttivaAttendere(true)
            setTendinaStato(false)
            await prodotti_fetch.eliminaInventario({prodottoId :parseInt(qtPrimaImp.prodottoId) , inventarioId :qtPrimaImp.ultimoInv.id})  
            await readQtPrimaImp()
            setTendinaStato(true)
            setAttivaAttendere(false)
        } 
        setConfermaElimina(false)
    }

    const recuperaDatiMod = () => {
        setInputsMod({
            qtAttualeRilevata : qtPrimaImp.qtAttuale,
            dataOraOperazione : format(new Date(qtPrimaImp.ultimoInv.dataInventario), "yyyy-MM-dd'T'HH:mm")
        });
        setAbilitaModInv(true);
    }

    console.log(inputsMod , 'inputsMod');
    

    return(
        <>
        {mostra && <InfoModal
                title = {'inventario  "'+ qtPrimaImp.nomeProd +'" , Magazzino centrale Ancona'}
                text = {
                    <>
                    <div className="ps-3">
                        {qtPrimaImp.ultimoInv != null ?<p className="d-flex align-items-baseline">
                            <h5 className="pe-3 ps-1 text-primary mt-5">Ultimo inventario:</h5>
                            <span className="me-4">
                                Quantità : {qtPrimaImp.ultimoInv.qta}
                            </span>
                            <span>
                                Data : { format(new Date(qtPrimaImp.ultimoInv.dataInventario), 'dd/MM/yyyy HH:mm') }
                            </span>
                            <p className="pb-0 mb-0 d-flex align-items-center" >
                                <button className="btn btn-primary ms-5 mb-1" disabled={!abilitaMod || abilitaCreaInv || abilitaModInv} onClick={()=>recuperaDatiMod()} >
                                    Modifica
                                </button>
                                <button className="btn btn-primary ms-5 mb-1" disabled={!abilitaMod || abilitaCreaInv || abilitaModInv} onClick={()=>setConfermaElimina(true)} >
                                    elimina
                                </button>
                                {!abilitaMod && <p className="fst-italic  pb-0 mb-0 ps-4" >Inventario non modificabile in quanto vi sono movimentazioni successive</p>}
                            </p>
                        </p> : 
                        <p className="d-flex align-items-center">
                            <h5 className="pe-3 ps-1 text-primary mt-5">Ultimo inventario:</h5>
                            <span className="mt-5">
                                Non disponibile
                            </span>
                        </p>

                        }
                        {!abilitaModInv && <div style={{border : '3px double #888'}} className="d-flex align-items-center border-start-0 border-bottom-0 pt-4 border-end-0 me-4 ">
                            <h5 className="ms-2 ps-0 text-primary">Aggiungi inventario</h5>
                            <button className="btn text-primary ms-2 mb-1 fs-2 p-1 " onClick={()=>setAbilitaCreaInv(true)}  >
                                    <FontAwesomeIcon icon={faCirclePlus} />
                            </button>
                        </div>}
                    </div>
                    <div className=" mb-2">
                        {abilitaCreaInv && <CreaInventario title='Aggiungi  ' onCloseInv={onCloseInv} setInputsCrea={setInputsCrea} inputsCrea={inputsCrea} error={qtPrimaImpError} />}
                        {abilitaModInv && <CreaInventario title='Modifica  ' onCloseInv={onCloseInvMod} setInputsCrea={setInputsMod} inputsCrea={inputsMod} error={qtPrimaImpError} />}
                        
                    </div>
                    <div className="ps-4">
                        <TendinaArrow 
                                title='Movimenti'
                                classi=" me-4"
                                stato={tendinaStato}
                                setStato={setTendinaStato}
                                contenuto={
                                    <ViewProdPopUp
                                        prodAnId={prodottoId}
                                        icona={' '}
                                        noPopUp
                                        soloMagazzino={[1,4]}
                                    />
                                }
                        />
                        <TendinaArrow 
                                title='Movimenti fino al 22/07/2025'
                                classi=" me-4"
                                stato={tendinaMovOldStato}
                                setStato={setTendinaMovOldStato}
                                contenuto={
                                    <TabProdSezioniOld prodottoId={prodottoId} />
                                }
                        />
                    </div>

                    </>
                }
                YesLabel = 'Salva'
                canClose
                handleClose = {()=>onCloseQt(0)}
                classi=' modal-xxl '
            />}
            {!!attivaAttendere && <Attendere />}
            <ConfermaEliminazione nome='inventario' stato={!!confermaElimina} conferma={deleteInv} />
            </>
    )
}